module.exports = __webpack_public_path__ + "static/media/halloween8.e1b48525.webp";